import { Button, VStack, Text, Flex } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import React, { ReactElement } from 'react';
import { ModalConfirmationProps, SharedModalProps } from 'types/Modal';
import { CloseIcon } from 'assets/icons/v2';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalConfirmationProps;

export const ConfirmationModal = ({ handleClose, isShown, onConfirm }: Props): ReactElement => {
  // const logout = useLogout();
  // const { clearUser: clearSentryUser } = useSentry();

  const handleLogout = (): void => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };
  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="sm">
      <CustomModalContent p="30px">
        <Flex direction="column" gap="30px">
          <Flex direction="column" align="flex-end" gap="5px">
            <NovaIconButton
              aria-label="Schließen"
              variant="primary"
              size="l"
              onClick={handleClose}
              icon={CloseIcon}
              iconProps={{ color: 'text.primary' }}
            />
            <VStack gap="15px" align="flex-start" w="full">
              <Text textStyle="h4.medium" color="text.primary">
                Benutzer entfernen
              </Text>
              <Text textStyle="body.m.regular" color="text.primary">
                Möchtest du den Benutzer wirklich aus der Organisation entfernen?
              </Text>
            </VStack>
          </Flex>

          <Flex gap="l" justify="flex-end">
            <Button onClick={handleClose} variant="tertiary">
              Abbrechen
            </Button>
            <Button onClick={handleLogout} variant="destructive">
              Entfernen
            </Button>
          </Flex>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
